import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Contact from "../pages/contact/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail/page";
import Partners from "../pages/partners/page";
import Privacy from "../pages/privacy/page";
import LegalNotice from "../pages/legal/page";
import Terms from "../pages/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/partners",
    element: <Partners />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/legal-notice",
    element: <LegalNotice />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;